import { api } from "./api";

export const poListApi = (params) => {
  return api.get(`/manufacturer/purchase-order/list`, { params });
};
export const poCsvDownloadApi = (params) => {
  return api.post(
    `/manufacturer/purchase-order/generate-csv`,
    JSON.stringify(params)
  );
};
export const poStateListApi = (params) => {
  return api.get(`/manufacturer/purchase-order/state-list`);
};

export const poDistributorListApi = (params) => {
  return api.get(
    `/manufacturer/purchase-order/distributor-list?state_id=${params.state_id}`
  );
};
export const poOfferTypeListApi = (params) => {
  return api.get(`/manufacturer/purchase-order/offer-list`);
};
export const generatePoInvoiceApi = (params) => {
  return api.post(
    `/manufacturer/purchase-order/generate`,
    JSON.stringify(params)
  );
};
export const poCsvSendMailApi = (params) => {
  return api.post(
    `/manufacturer/purchase-order/send-mail-po`,
    JSON.stringify(params)
  );
};

export const poViewApi = (params) => {
  console.log(params, "papapapapapapa");
  return api.get(`/manufacturer/purchase-order/view`, { params: params });
};